/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".article-modal-container{width:80%;height:calc(100% - 50px)}.article-modal-container .mat-dialog-container,.article-modal-container .mat-dialog-content{height:100%;max-height:100%}.article-modal-container .close-button{position:absolute;top:0;right:20px}"];
export { styles as styles };
